import { useGameContext } from "./useGameContext";
export function usePlayerId() {
    return useGameContext('playerId');
}
export function useGameId() {
    return useGameContext('gameId');
}
export function useGameInitialized() {
    return useGameContext('gameInitialized');
}
export function useGameLifecycleStage() {
    return useGameContext('gameLifecycleStage');
}
export function useHost() {
    return useGameContext('host');
}
export function useLastGameSummary() {
    return useGameContext('lastGameSummary');
}
//# sourceMappingURL=GameContextHooks.js.map